
import { defineComponent, ref } from '@nuxtjs/composition-api'
import { setupTranslationPrefixer } from '~/assets/translation'
import LogoDeltaLife from '~/components/Atom/Brand/LogoDeltaLife'

export default defineComponent({
  components: { LogoDeltaLife },
  props: {
    templateName: { type: String, required: false, default: undefined },
    image: { type: Object, required: false, default: undefined },
    markers: { type: Object, required: false, default: () => {} },
  },
  setup() {
    const activePanel = ref(null)

    const toggleInfoPanel = (position) => {
      if (activePanel.value === position) {
        activePanel.value = null
      } else {
        activePanel.value = position
      }
    }

    return {
      ...setupTranslationPrefixer('interactive-map'),
      activePanel,
      toggleInfoPanel,
    }
  },
  data() {
    return {
      darkTheme: this.templateName === 'homePage',
    }
  },
})
